"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("../classnames"));
var Tooltip_1 = __importDefault(require("./Tooltip"));
var colors = {
    darkblue: "db",
    green: "gr",
    lightblue: "lb",
    yellow: "yw"
};
var CheerSVG = function (_a) {
    var className = _a.className, _b = _a.color, color = _b === void 0 ? "darkblue" : _b, _c = _a.pop, pop = _c === void 0 ? false : _c, _d = _a.small, small = _d === void 0 ? false : _d;
    return (react_1.default.createElement("svg", { className: classnames_1.default("chq-chr", className, "chq-chr-" + colors[color], {
            "chq-chr-pp": pop,
            "chq-chr-sm": small
        }), viewBox: "0 0 344 512" },
        react_1.default.createElement("path", { d: "m331 25c-11-9-27-8-36 3l-88 104c-4 4-9 7-16 7l-40 0c-5 0-12-3-16-7l-88-104c-9-11-25-12-36-3-11 9-12 25-3 36l100 120 0 143 0 8 0 152c0 15 12 25 25 25 15 0 25-12 25-25l0-152 20 0 0 152c0 15 12 25 25 25 15 0 25-12 25-25l0-152 0-8 0-143 100-120c9-11 8-26 2-37z" }),
        react_1.default.createElement("circle", { r: "55", cy: "60", cx: "171" }),
        pop && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("circle", { className: "chq-chr--fb chq-chr--fb-1", r: "40", cy: "0", cx: "-24" }),
            react_1.default.createElement("circle", { className: "chq-chr--fb chq-chr--fb-7", r: "40", cy: "0", cx: "364" }),
            react_1.default.createElement("circle", { className: "chq-chr--fb chq-chr--fb-2", r: "40", cy: "-54", cx: "31" }),
            react_1.default.createElement("circle", { className: "chq-chr--fb chq-chr--fb-6", r: "40", cy: "-54", cx: "309" }),
            react_1.default.createElement("circle", { className: "chq-chr--fb chq-chr--fb-3", r: "40", cy: "-86", cx: "96" }),
            react_1.default.createElement("circle", { className: "chq-chr--fb chq-chr--fb-5", r: "40", cy: "-86", cx: "244" }),
            react_1.default.createElement("circle", { className: "chq-chr--fb chq-chr--fb-4", r: "40", cy: "-101", cx: "170" })))));
};
var Cheer = function (_a) {
    var name = _a.name, props = __rest(_a, ["name"]);
    if (name) {
        return react_1.default.createElement(Tooltip_1.default, { tip: name },
            react_1.default.createElement(CheerSVG, __assign({}, props)));
    }
    return react_1.default.createElement(CheerSVG, __assign({}, props));
};
exports.default = Cheer;
